import React from 'react';
import { Typography } from 'antd';
import DataCard from '../page/DataCard';
import { BarList } from '../charts';

const { Text } = Typography;

/**
 * Summary above the mapping table, drawn only from GET /control-taxonomy/frameworks.
 * Frameworks with no loaded controls are left out (nothing to count), never shown as 0%.
 * A framework x ISO-theme heat strip is deliberately not drawn: the matrix endpoint is paged, so a
 * theme breakdown computed client-side would describe one page, not the whole mapping.
 */
const TaxonomyCoverageStrip = ({ frameworks }) => {
  const loaded = (frameworks || []).filter((f) => f.loaded && f.controlCount > 0);
  if (!loaded.length) return null;
  return (
    <DataCard size="small" data-testid="taxonomy-coverage-strip" title="Mapping coverage">
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 32 }}>
        <div style={{ flex: '1 1 320px', minWidth: 0 }}>
          <Text type="secondary">Controls mapped to ISO 27002</Text>
          <BarList
            label="Mapped controls per regulation"
            testId="taxonomy-mapped-bars"
            rows={loaded.map((f) => ({
              key: f.key,
              label: f.label,
              value: f.mappedControlCount,
              max: f.controlCount,
              valueText: `${f.mappedControlCount} of ${f.controlCount}`,
            }))}
          />
        </div>
        <div style={{ flex: '1 1 320px', minWidth: 0 }}>
          <Text type="secondary">ISO 27002 controls each regulation maps to</Text>
          <BarList
            label="ISO controls reached per regulation"
            testId="taxonomy-iso-bars"
            rows={loaded.map((f) => ({ key: f.key, label: f.label, value: f.mappedIsoCount, valueText: String(f.mappedIsoCount) }))}
          />
        </div>
      </div>
    </DataCard>
  );
};

export default TaxonomyCoverageStrip;
